// extracted by mini-css-extract-plugin
export var aboutTeam = "AboutTeam-module--aboutTeam--hayyo";
export var aboutTeamContainer = "AboutTeam-module--aboutTeamContainer--tpiIL";
export var aboutTeamPhoto = "AboutTeam-module--aboutTeamPhoto--r0aAH";
export var employee = "AboutTeam-module--employee--RpqTR";